export default __webpack_public_path__ + "static/media/1_15.1e5e8f81.png";